import { SUCCESS, FETCH_WHOS_HERE_MESSAGES_UNREAD } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';

export default (state = initialState.whosHereMessages, { type, payload }) => {
  switch (type) {
    case FETCH_WHOS_HERE_MESSAGES_UNREAD + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
